"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "mb-4 leading-4.5" };
const _hoisted_2 = { class: "whitespace-nowrap" };
const store_1 = require("@/state/store");
const sharedFunctions_1 = require("@/services/sharedFunctions");
const main_1 = require("@/main");
exports.default = (0, vue_1.defineComponent)({
    __name: 'IntroductionText',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_1, [
                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)((0, vue_2.unref)(store_1.store).isLogin ? "login.formText" : "registration.formText")) + " ", 1),
                (0, vue_2.createElementVNode)("span", _hoisted_2, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "cursor-pointer font-semibold text-black-primary underline hover:text-black",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(sharedFunctions_1.switchLoginAndRegister)('Top')))
                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)((0, vue_2.unref)(store_1.store).isLogin ? "login.switch_link" : "registration.switch_link")), 1)
                ])
            ]));
        };
    }
});
